import React from 'react';

const ValidationErrors = ({ validationErrors, validationStatus }) => {
  if (!validationErrors || validationErrors.length === 0) return null;

  return (
    <div className="validation-errors">
      <div className="validation-header">
        <h4>Validation Issues</h4>
        <span className="error-count">{validationErrors.length} error(s)</span>
      </div>
      <ul className="error-list">
        {validationErrors.map((error, index) => (
          <li key={index} className="error-item">
            <span className="error-icon">⚠</span>
            <span className="error-text">{error}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ValidationErrors;
